import React, { useState } from 'react';
import {
    MDBSideNav,
    MDBSideNavMenu,
    MDBBtn,
} from 'mdb-react-ui-kit';
import Session from './MainFilters/Session';
import Subjects from './MainFilters/Subjects';
import Committee from './MainFilters/Committee';
import Progress from './MainFilters/Progress';
import Legislator from './MainFilters/Legislator';
import Party from './MainFilters/Party';
import BillType from './MainFilters/BillType';
import Chamber from './MainFilters/Chamber';
import Status from './MainFilters/Status';
import OtherFilters from './OtherFilters/OtherFilters';
import FilterHeader from './FilterHeader';
import Chapters from './MainFilters/Chapters';
import Requestors from './MainFilters/Requestor';

const Filter = ({ activeSessionInfo, sideNavToggle, setSideNavToggle, container, setSessionId, setSubjectCode, sessionId,
                    selectedBillTypes, setSelectedBillTypes, selectedLegislator, setSelectedLegislator,
                    setOffset, selectedDrafter, setSelectedDrafter, selectedParties, setSelectedParties,
                    selectedChambers, setSelectedChambers,  billTypesCount,  partyCount, chambersCount,
                    selectedCommittee, setSelectedCommitte, setSelectedProgress, setHasAmendment, setHasFiscalNotes,
                    setHasLegalNotes, deadlineCategoriesCount, selectedDeadlines, setSelectedDeadlines , setLegislatureId,
                    legislatureId, hasAmendment, hasFiscalNotes, hasLegalNotes, subjectCode, selectedProgress, selectedActionTypes,
                    setSelectedActionTypes, statusStartDate, setStatusStartDate, statusEndDate, setStatusEndDate,
                    chaptersCount, setChaptersCount, selectedChapters, setSelectedChapters, sessionInfoForHeader, setSessionInfoForHeader,
                    hasPreIntroductionRequired, setHasPreIntroductionRequired, requestor, setRequestor, requestorType, setRequestorType,
                    byRequestOf, setByRequestOf, byRequestOfType, setByRequestOfType, showSaveFilterModal, setShowSaveFilterModal
                }) => {


    const handleClearFilter = () => {
        setSessionId(activeSessionInfo.id);
        setSessionInfoForHeader(`${new Date(activeSessionInfo.startDate).getFullYear().toString()} (${activeSessionInfo.type})`)
        setSubjectCode([]);
        setSelectedBillTypes([]);
        setSelectedLegislator("");
        setOffset(0);
        setSelectedDrafter("");
        setSelectedParties([]);
        setSelectedChambers([]);
        setSelectedCommitte("");
        setSelectedProgress("");
        setSelectedActionTypes(false);
        setHasAmendment(false);
        setHasFiscalNotes(false);
        setHasLegalNotes(false);
        setSelectedDeadlines([]);
        setLegislatureId(null);
        setStatusEndDate(null);
        setStatusStartDate(null);
        setSelectedChapters([]);
        setHasPreIntroductionRequired(false);
        setRequestor(false);
        setRequestorType(false);
        setByRequestOf(false);
        setByRequestOfType(false);
    }

    const handleSaveFilters = () => {
        console.log("It's clicking...");
        setShowSaveFilterModal(!showSaveFilterModal);
    };

    return (
        <>
            <MDBSideNav isOpen={sideNavToggle} style={{ transition: 'all 0.2s linear 0s' , width:'350px', position: 'fixed' }} contentRef={container} mode={'side'} absolute getOpenState={(e) => setSideNavToggle(e)}>
                <MDBSideNavMenu>
                    <FilterHeader setSideNavToggle={setSideNavToggle} />
                    <Session sessionId={sessionId} setSessionId={setSessionId} setOffset={setOffset} setSelectedLegislator={setSelectedLegislator} setLegislatureId={setLegislatureId} sessionInfoForHeader={sessionInfoForHeader} setSessionInfoForHeader={setSessionInfoForHeader}/>
                    <Chamber selectedChambers={selectedChambers} setSelectedChambers={setSelectedChambers} setOffset={setOffset} chambersCount={chambersCount}/>
                    <BillType selectedBillTypes={selectedBillTypes} setSelectedBillTypes={setSelectedBillTypes} setOffset={setOffset} billTypesCount={billTypesCount} sessionId={sessionId}/>
                    <Chapters setChaptersCount={setChaptersCount} chaptersCount={chaptersCount} selectedChapters={selectedChapters} setSelectedChapters={setSelectedChapters} setOffset={setOffset} sessionId={sessionId}/>
                    <Subjects setSubjectCode={setSubjectCode} setOffset={setOffset} subjectCode={subjectCode} sessionId={sessionId}/>
                    <Legislator sessionId={sessionId} selectedLegislator={selectedLegislator} setSelectedLegislator={setSelectedLegislator}  setOffset={setOffset} legislatureId={legislatureId}/>
                    <Requestors
                        sessionId={sessionId}
                        seRequestorsssionId={sessionId}
                        setOffset={setOffset}
                        requestor={requestor}
                        setRequestor={setRequestor}
                        requestorType={requestorType}
                        setRequestorType={setRequestorType}
                        byRequestOf={byRequestOf}
                        setByRequestOf={setByRequestOf}
                        byRequestOfType={byRequestOfType}
                        setByRequestOfType={setByRequestOfType}
                    />
                    <Committee sessionId={sessionId} selectedCommittee={selectedCommittee} setSelectedCommitte={setSelectedCommitte} setOffset={setOffset} legislatureId={legislatureId} />
                    <Party sessionId={sessionId} setOffset={setOffset} selectedParties={selectedParties} setSelectedParties={setSelectedParties}  partyCount={partyCount}  setSelectedLegislator={setSelectedLegislator} />
                    <Progress sessionId={sessionId} setOffset={setOffset}  setSelectedProgress={setSelectedProgress} selectedProgress={selectedProgress}/>
                    <Status
                        sessionId={sessionId}
                        selectedActionTypes={selectedActionTypes}
                        setSelectedActionTypes={setSelectedActionTypes}
                        setOffset={setOffset}
                        setStatusStartDate={setStatusStartDate}
                        setStatusEndDate={setStatusEndDate}
                        statusStartDate={statusStartDate}
                        statusEndDate={statusEndDate}
                    />
                    <OtherFilters
                        sessionId={sessionId}
                        selectedDrafter={selectedDrafter}
                        setSelectedDrafter={setSelectedDrafter}
                        setOffset={setOffset}
                        setHasAmendment={setHasAmendment}
                        setHasFiscalNotes={setHasFiscalNotes}
                        deadlineCategoriesCount={deadlineCategoriesCount}
                        selectedDeadlines={selectedDeadlines}
                        setSelectedDeadlines={setSelectedDeadlines}
                        hasAmendment={hasAmendment}
                        hasFiscalNotes={hasFiscalNotes}
                        hasLegalNotes={hasLegalNotes}
                        setHasLegalNotes={setHasLegalNotes}
                        hasPreIntroductionRequired={hasPreIntroductionRequired}
                        setHasPreIntroductionRequired={setHasPreIntroductionRequired}
                    />
                    <div className='text-center'>
                        <MDBBtn onClick={handleClearFilter} className='shadow-none m-2' size='sm' color="dark">Clear Filter</MDBBtn>
                        {/*{ process.env.REACT_APP_ENV === 'PRODUCTION' ?
                            <></>
                            :
                            <>
                                <MDBBtn className='shadow-none m-2' size='sm' >Save Results as Lists</MDBBtn>
                                <MDBBtn onClick={handleSaveFilters}  className='shadow-none' size='sm'>Save Filters</MDBBtn>
                            </>
                        }*/}

                    </div>
                </MDBSideNavMenu>
            </MDBSideNav>
        </>
    );
}

export default Filter;


